import React from 'react';
import PropTypes from 'prop-types';


const Schedule = (props) => {
  const {
    daysArr,
    daysIndex,
    timeSlots,
  } = props;
  const daysIndexes = Object.keys(daysIndex);

  return (
    <li className="tour-schedule__item">
      <div className="tour-schedule__item-block tour-schedule__item-days">
        {
          daysIndexes.map((item) => {
            return (
              <p key={`time_slot_key_${daysArr[item]}`}>
                {daysArr[item]}
              </p>
            )
          })
        }
      </div>
      <div className="tour-schedule__item-block tour-schedule__item-time">
        {
          timeSlots.map((item) => {
            return (
              <div key={`time_slots_${item.startTime}_ ${item.endTime}`}>
                <span>{item.startTime} </span>-
                <span> {item.endTime}</span>
              </div>
            )
          })
        }
      </div>
    </li>
  )
};

Schedule.propTypes = {
  daysArr: PropTypes.array,
  daysIndex: PropTypes.object,
  timeSlots: PropTypes.array,
};

class DaysTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      daysArr: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      schedules: []
    }
  }

  componentWillMount(){
    this.setData(this.props)
  }

  setData(props){
    if (props.tourDates && props.tourDates.length > 0) {
      const data = props.tourDates;

      const groupData = {};
      for (let i = 0; i < data.length; i++) {
        if (!groupData[data[i].groupName])
          groupData[data[i].groupName] = [];
        let isAdd = true;
        for (let k = 0; k < groupData[data[i].groupName].length; k++) {
          if (groupData[data[i].groupName][k].startTime === data[i].startTime && groupData[data[i].groupName][k].endTime === data[i].endTime) {
            isAdd = false;
          }
        }

        if (isAdd) {
          groupData[data[i].groupName].push({
            startTime: data[i].startTime,
            endTime: data[i].endTime
          });
        }
      }

      const groupDataKeys = Object.keys(groupData);

      const schedules = [];
      for (let i = 0; i < groupDataKeys.length; i++) {
        const schedule = {};
        schedule.daysIndex = {};
        const indexDays = groupDataKeys[i].split('_');

        for (let k = 0; k < indexDays.length; k++) {
          schedule.daysIndex[indexDays[k]] = true;
        }
        schedule.timeSlots = groupData[groupDataKeys[i]];
        schedules.push(schedule)
      }
      this.setState({schedules});
    }
  }

  render() {

    const {
      schedules,
      daysArr,
    } = this.state;

    return (
      <div>
        {
          schedules.length > 0 ?
            <div className="tour-schedule__wrap">
              <ul className="tour-schedule__column-title">
                <li className="tour-schedule__column-item">Days</li>
                <li className="tour-schedule__column-item">Time</li>
              </ul>
              <ul className="tour-schedule__list">
                {
                  schedules.map((item, index) => {
                    return (
                      <Schedule
                        key={`schedule_component-${JSON.stringify(item.daysIndex)}`}
                        daysArr={daysArr}
                        scheduleIndex={index}
                        daysIndex={item.daysIndex}
                        timeSlots={item.timeSlots}
                      />
                    )
                  })
                }
              </ul>
            </div> : null
        }
      </div>
    )
  }
}

export default DaysTable;


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/TourDates/index.js